
import firebase from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyBR3ogOL54yoMaKceNVi7JrapqU9XKDYyQ",
  authDomain: "post-trans.firebaseapp.com",
  databaseURL: "https://post-trans-default-rtdb.firebaseio.com",
  projectId: "post-trans",
  storageBucket: "post-trans.appspot.com",
  messagingSenderId: "817261599623",
  appId: "1:817261599623:web:f0bc16cc43ef1e53381122",
  measurementId: "G-Y6XE911EGL"
};
  
 // Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);

export default firebase;
